import AlertModal from './AlertModal';

export default AlertModal;



// WEBPACK FOOTER //
// ./src/views/components/Common/AlertModal/index.js